import { render } from "./StudentsSocialPaymentView.vue?vue&type=template&id=753e5da2&scoped=true"
import script from "./StudentsSocialPaymentView.vue?vue&type=script&lang=js"
export * from "./StudentsSocialPaymentView.vue?vue&type=script&lang=js"

import "./StudentsSocialPaymentView.vue?vue&type=style&index=0&id=753e5da2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753e5da2"]])

export default __exports__